import { Action } from '../../actions';
import { CHANGE_ID_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/changeIdCampaignServiceEditor';
import { CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/changeMobileCampaignServiceEditor';
import { CLOSE_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/closeCampaignServiceEditor';
import { INIT_CAMPAIGN_SERVICE_EDITORS } from '../../actions/campaignServiceEditor/initCampaignServiceEditors';
import { OPEN_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/openCampaignServiceEditor';
import { REVERT_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/revertCampaignServiceEditor';
import { SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR } from '../../actions/campaignServiceEditor/showErrorsCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

import { changeIdCampaignServiceEditor } from './changeIdCampaignServiceEditor';
import { changeMobileCampaignServiceEditor } from './changeMobileCampaignServiceEditor';
import { closeCampaignServiceEditor } from './closeCampaignServiceEditor';
import { initCampaignServiceEditors } from './initCampaignServiceEditors';
import { openCampaignServiceEditor } from './openCampaignServiceEditor';
import { revertCampaignServiceEditor } from './revertCampaignServiceEditor';
import { showErrorsCampaignServiceEditor } from './showErrorsCampaignServiceEditor';

export const campaignServiceEditor = (
    state: CampaignServiceEditorState = {},
    action: Action
): CampaignServiceEditorState => {
    switch (action.type) {
        case INIT_CAMPAIGN_SERVICE_EDITORS:
            return initCampaignServiceEditors(state, action);
        case OPEN_CAMPAIGN_SERVICE_EDITOR:
            return openCampaignServiceEditor(state, action);
        case CLOSE_CAMPAIGN_SERVICE_EDITOR:
            return closeCampaignServiceEditor(state, action);
        case CHANGE_ID_CAMPAIGN_SERVICE_EDITOR:
            return changeIdCampaignServiceEditor(state, action);
        case CHANGE_MOBILE_CAMPAIGN_SERVICE_EDITOR:
            return changeMobileCampaignServiceEditor(state, action);
        case REVERT_CAMPAIGN_SERVICE_EDITOR:
            return revertCampaignServiceEditor(state, action);
        case SHOW_ERRORS_CAMPAIGN_SERVICE_EDITOR:
            return showErrorsCampaignServiceEditor(state, action);
        default:
            return state;
    }
};
